<template>
	<div>
		<div class="row">
			<div class="col-sm-2">
				<span>CNAE CÓDIGO</span>
				<select class="form-control" v-model="dTec.cnae.cod">
					<option
						v-for="(atv, index) in atividades"
						:key="index"
						:value="atv.code"
					>
						{{ atv.code }}
					</option>
				</select>
			</div>
			<div class="col-sm-8">
				<span>CNAE DESCRIÇÃO CLIENTE</span>
				<input
					type="text"
					v-model="dTec.cnae.desc"
					disabled
					class="form-control"
				/>
			</div>
			<div class="col-sm-2">
				<span>G R CLIENTE</span>
				<input class="form-control" v-model="dTec.grauRisco" disabled />
			</div>
		</div>
		<br />
		<div class="row">
			<div class="col-sm-2">
				<span>CIPA - GRUPO</span>
				<input
					type="text"
					v-model="dTec.cipa.grupo"
					disabled
					class="form-control"
				/>
			</div>

			<div class="col-sm-4">
				<span>Atividade Econômica</span>
				<input
					v-model="dTec.cipa.atividade_economica"
					disabled
					class="form-control"
				/>
			</div>

			<div class="col-sm-2">
				<span>EFETIVOS</span>
				<input
					type="number"
					disabled
					v-model="dTec.efetivo"
					class="form-control"
				/>
			</div>
			<div class="col-sm-2">
				<span>SUPLENTES</span>
				<input
					type="number"
					disabled
					v-model="dTec.suplente"
					class="form-control"
				/>
			</div>
			<div class="col-sm-2">
				<span>C. MEMBROS</span>
				<input
					type="number"
					disabled
					v-model="dTec.cipa.membros"
					class="form-control"
				/>
			</div>
		</div>
		<br />
		<div class="row">
			<div class="col-sm-4">
				<span>TÉCNICO EDITOR</span>
				<select v-model="dTec.tecnico.editor" class="form-control">
					<option value="">NENHUM</option>
					<option
						v-for="(tech, index) in renderTech"
						:key="index"
						:value="tech.editor"
					>
						{{ tech.name }}
					</option>
				</select>
			</div>
			<div class="col-sm-3">
				<span>REGISTRO TÉCNICO</span>
				<input
					disabled
					v-model="dTec.tecnico.registro"
					class="form-control"
				/>
			</div>
			<div class="col-sm-5">
				<span>QUALIFICAÇÃO TÉCNICA</span>
				<select
					v-model="dTec.tecnico.qualificacao"
					disabled
					class="form-control"
				>
					<option value="">NENHUM</option>
					<option value="TST">
						TÉCNICO EM SEGURANÇA DO TRABALHO
					</option>
					<option value="TET">TÉCNICO EM ENFERMAGEM</option>
					<option value="MED">MÉDICO DO TRABALHO</option>
					<option value="ENF">ENFERMEIRO DO TRABALHO</option>
					<option value="ENG">ENGENHEIRO EM SEG DO TRABALHO</option>
				</select>
			</div>
		</div>
	</div>
</template>
<script>
	import { clone } from 'lodash';
	import UpdateCneaMixin from '../js/cnae_update.mixin.js';
	import GetData from '../js/getData.mixins.js';

	export default {
		name: 'DadosTecnicos',
		inject: ['row', 'assets'],
		props: ['dIn'],
		mixins: [UpdateCneaMixin, GetData],
		watch: {
			'dTec.cnae.cod': function (val) {
				let atv = this.atividades.find((atv) => atv.code == val);
				if (atv != undefined) this.dTec.cnae.desc = atv.text;
				this.$emit('call', {
					method: 'update_cnea_cod',
					payload: val,
				});
			},
			'dTec.tecnico.editor': function (val) {
				if (val != '') {
					var tech = this.renderTech.find(
						(tech) => tech.editor == val
					);
					this.$set(this.dTec, 'tecnico', clone(tech));
				} else {
					this.$set(
						this.dTec,
						'tecnico',
						clone({
							editor: '',
							registro: '',
							qualificacao: '',
						})
					);
				}
			},
		},
		computed: {
			renderTech() {
				let resp = [];
				if (this.assets.tecnicos == null) return resp;
				this.assets.tecnicos.forEach((tech) => {
					let itTech = {
						editor: tech.uid.uid,
						name: tech.uid.nome + ' ' + tech.uid.sobrenome,
						cpf: tech.uid.cpf,
						registro: this.get_data('mtd_rTecnico', tech.metadata),
						qualificacao: this.get_data(
							'mtd_qTecnica',
							tech.metadata
						),
					};

					if (
						(itTech.registro != null && itTech.registro != '') ||
						(itTech.qualificacao != null &&
							itTech.qualificacao != '')
					) {
						resp.push(itTech);
					}
				});
				return resp;
			},
			dTec() {
				return this.dIn;
			},
			atividades: function () {
				let atvPrinc = this.row.cnpj.sst_data.atividade_principal;
				let atvSec = this.row.cnpj.sst_data.atividades_secundarias;
				return atvPrinc.concat(atvSec);
			},
		},
		mounted() {
			if (this.dTec.cnae.cod == '') {
				this.dTec.cnae.cod = this.row.cnpj.sst_data.atividade_sel;
			}
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/order-of-service/components/actions-components/map-components/dados-tecnicos.vue